import './index.css'

import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../../Header'
import CheckboxGroup from '../../CheckboxGroup'
import InputDisabled from '../../InputDisabled'
import Empty from '../../Empty'
import ArrowDownSvg from '../../../assets/icons/ArrowDownSvg'
import IlceModal from './Modals/IlceModal'
import MahalleModal from './Modals/MahalleModal'
import ConditionsCheckBox from '../ApplicationsForm/ConditionsCheckBox'
import { Button } from 'reactstrap'
import TubitakWarningModal from './Modals/TubitakWarningModal'
import axios from 'axios'
import LoadingAbsolute from '../../LoadingAbsolute'
import WarningSvg from '../../../assets/icons/WarningSvg'

const ApplicationsForm = (props) => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [selectedValue, setSelectedValue] = useState('Öğrenci')
  const [labelAddress, setLabelAddress] = useState('')
  const [selectedAddress, setSelectedAdress] = useState(
    labelAddress === '' ? 'yeni' : 'ikametgah'
  )
  const [selectedIlce, setSelectedIlce] = useState('KARATAY')
  const [selectedMahalle, setSelectedMahalle] = useState('Seçiniz...')
  const [selectedMahalleId, setSelectedMahalleId] = useState(null)
  const [studendtTC, setStudendtTC] = useState('')
  const [TC, setTC] = useState('')
  const [ilceModalOpen, setIlceModalOpen] = useState(false)
  const [mahalleModalOpen, setMahalleModalOpen] = useState(false)
  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })
  const [ilceId, setIlceId] = useState(684)
  const [secondAdress, setSecondAdress] = useState('')
  const [checkbox, setCheckbox] = useState(false)
  const [mahalleLabelClass, setMahalleLabelClass] = useState('selectLabel')
  const [adressLabelClass, setAdressLabelClass] = useState('selectLabel')
  const [mahalleInputClass, setMahalleInputClass] = useState('selectInput')
  const [adressInputClass, setAdressInputClass] = useState('selectTextArea')
  const [mahalleler, setMahalleler] = useState(null)
  const [ilceler, setIlceler] = useState(null)
  const [labelName, setLabelName] = useState(null)
  const [labelSurname, setLabelSurname] = useState(null)
  const [dergi, setDergi] = useState(null)
  const [isIkametgah, setIsIkametgah] = useState(false)
  const [isDergi, setIsDergi] = useState(false)

  const onFinish = () => {
    if (selectedAddress === 'yeni') {
      if (selectedIlce === 'KARATAY' && selectedMahalle === 'Seçiniz...') {
        setMahalleInputClass('unSelectInput')
        setMahalleLabelClass('unSelectLabel')
      } else {
        setMahalleInputClass('selectInput')
        setMahalleLabelClass('selectLabel')
      }

      if (secondAdress?.length >= 10) {
        setAdressInputClass('selectTextArea')
        setAdressLabelClass('selectLabel')
      } else {
        setAdressInputClass('unSelectInput')
        setAdressLabelClass('unSelectLabel')
      }

      if (!checkbox && secondAdress?.length >= 10 && selectedMahalleId) {
        setWarningModalOpen({ state: 'checkbox', active: true })
      } else if (checkbox && secondAdress?.length >= 10 && (selectedIlce === 'KARATAY' ? selectedMahalleId : true)) {
        setWarningModalOpen({ state: 'success', active: true })
      }
    } else {
      if (!checkbox) {
        setWarningModalOpen({ state: 'checkbox', active: true })
      } else {
        setWarningModalOpen({ state: 'success', active: true })
      }
    }
  }

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/ogrenci_sorgula`,
        {
          params: {
            token: JSON.parse(localStorage.getItem('token')),
          },
        }
      )
      .then((res) => {
        setLoading(false)
        if (res.data.code === 200 && res.data.are_there_student) {
          setStudendtTC(true)
          setMahalleler(res.data.mahalleler)
          setIlceler(res.data.ilceler)
          setLabelName(res.data.name)
          setLabelSurname(res.data.surname)
          setLabelAddress(res.data.address)
          setSelectedAdress(res.data.address === '' ? 'yeni' : 'ikametgah')
          setIsIkametgah(res.data.address === '')
          setDergi(res.data.dergi)
          setIsDergi(state?.basvuru_id === res.data.basvuru_id)
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
  }, [state])

  const checkStudent = () => {
    return new Promise((resolve, reject) => {
      setLoading(true)
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/veli_ogrenci_sorgula`,
          {
            params: {
              token: JSON.parse(localStorage.getItem('token')),
              ogrenci_tc_no: TC,
            },
          }
        )
        .then((res) => {
          setLoading(false)
          if (res.data.code === 200 && res.data.are_there_student) {
            setStudendtTC(TC)
            setMahalleler(res.data.mahalleler)
            setIlceler(res.data.ilceler)
            setLabelName(res.data.name)
            setLabelSurname(res.data.surname)
            setLabelAddress(res.data.address)
            setSelectedAdress(res.data.address === '' ? 'yeni' : 'ikametgah')
            setIsIkametgah(res.data.address === '')
            setDergi(res.data.dergi)
            setIsDergi(state?.basvuru_id === res.data.basvuru_id)
            resolve(res)
          } else {
            resolve(res)
          }
        })
    })
  }

  const picture_data = [
    {
      id: '1',
      image: 'merakli-minik-kapak.png',
    },
    {
      id: '2',
      image: 'bilim-cocuk-kapak.png',
    },
    {
      id: '3',
      image: 'bilim-ve-teknik-kapak.png',
    },
  ]

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={
              'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' +
              state?.basvuru_fotografi
            }
            alt=''
            width={'90%'}
            height={'100%'}
            style={{ borderRadius: '10px' }}
          />
        </div>

        <div className='divider' />
        <CheckboxGroup
          title={'Başvuruyu Kim Yapıyor?'}
          label1={'Öğrenci'}
          label2={'Veli'}
          value1={'Öğrenci'}
          value2={'Veli'}
          selectedValue={selectedValue}
          setSelectedValue={setSelectedValue}
          TC={TC}
          studendtTC={studendtTC}
        />

        {!studendtTC && selectedValue === 'Öğrenci' ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '1rem',
            }}
          >
            <Empty tubitak={true} />
          </div>
        ) : studendtTC ? (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {selectedValue === 'Veli' && TC && (
                <div
                  style={{
                    marginLeft: '1.3rem',
                    marginRight: '0.5rem',
                    marginTop: '1rem',
                    width: '98%',
                  }}
                >
                  <div className='dergiTitle'>Öğrenciye Ait T.C. Kimlik No</div>
                  <input
                    value={TC}
                    className='tcInputDisable'
                    disabled={true}
                  />
                </div>
              )}
              <div className='userInfoDiv'>
                <InputDisabled label={selectedValue === 'Öğrenci' ? 'Adınız' : "Öğrencinin Adı"} value={labelName} />
                <InputDisabled label={selectedValue === 'Öğrenci' ? 'Soyadınız' : "Öğrencinin Soyadı"} value={labelSurname} />
              </div>
              {selectedAddress === 'ikametgah' && (
                <div
                  style={{
                    marginLeft: '1.3rem',
                    marginRight: '0.5rem',
                    width: '98%',
                  }}
                >
                  <InputDisabled
                    label={'İkamet Adresiniz'}
                    value={labelAddress}
                    textArea={true}
                  />
                </div>
              )}
            </div>

            {!isIkametgah && (
              <CheckboxGroup
                title={'Derginin Gönderileceği Adres'}
                label1={'İkametgah Adresime Gönderilsin'}
                label2={'Yeni Adres Girmek İstiyorum'}
                value1={'ikametgah'}
                value2={'yeni'}
                selectedValue={selectedAddress}
                setSelectedValue={setSelectedAdress}
                address={true}
              />
            )}
            {selectedAddress === 'yeni' && (
              <>
                <div
                  style={{
                    padding: '1rem 1.5rem',
                  }}
                >
                  <div
                    className='selectInputDiv'
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '0.4rem',
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                      }}
                    >
                      <div className='selectLabel'>İlçe</div>
                      <div
                        className='selectInput'
                        onClick={() => setIlceModalOpen(true)}
                      >
                        <div>{selectedIlce}</div>{' '}
                        <ArrowDownSvg width={'1rem'} height={'1rem'} />
                      </div>
                    </div>

                    {selectedIlce === 'KARATAY' && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          width: '100%',
                        }}
                      >
                        <div>
                          <div className={mahalleLabelClass}>Mahalle</div>
                          <div
                            className={mahalleInputClass}
                            onClick={() => setMahalleModalOpen(true)}
                          >
                            <div>{selectedMahalle}</div>
                            <ArrowDownSvg
                              width={'1rem'}
                              height={'1rem'}
                              stroke={
                                mahalleInputClass === 'unSelectInput'
                                  ? 'red'
                                  : '#b5ccc2'
                              }
                            />
                          </div>
                        </div>
                        {mahalleInputClass === 'unSelectInput' && (
                          <div
                            style={{
                              marginTop: '0.1rem',
                              marginLeft: '0.5rem',
                              fontSize: '9px',
                              color: 'red',
                            }}
                          >
                            Bu Alan Zorunludur.
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    marginLeft: '1.5rem',
                    marginRight: '0.5rem',
                  }}
                >
                  <div className={adressLabelClass}>Adresiniz</div>
                  <textarea
                    className={adressInputClass}
                    value={secondAdress}
                    onChange={(e) => {
                      if (e.target.value?.length >= 10) {
                        setAdressInputClass('selectTextArea')
                        setAdressLabelClass('selectLabel')
                      }
                      setSecondAdress(e.target.value)
                    }}
                    rows='3'
                    placeholder='Cadde, sokak, site/bina adı, daire numarasını eksiksiz olarak giriniz...'
                  ></textarea>
                  {adressInputClass === 'unSelectInput' && (
                    <div
                      style={{
                        marginTop: '0.1rem',
                        marginLeft: '0.5rem',
                        fontSize: '9px',
                        color: 'red',
                      }}
                    >
                      {secondAdress?.length === 0
                        ? 'Bu Alan Zorunludur.'
                        : 'En az 10 karakter olmalıdır.'}
                    </div>
                  )}
                </div>
              </>
            )}
            <div
              style={{
                marginLeft: '1.5rem',
                marginRight: '0.5rem',
                marginTop: '1rem',
              }}
            >
              <div className='dergiTitle'>Abone Olabileceğiniz Dergi</div>
              {isDergi ? (
                <>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      marginRight: '1rem',
                      marginTop: '0.5rem',
                    }}
                  >
                    {picture_data.map((item) => {
                      return (
                        <div key={item.id} className='dergiImage'>
                          {item.id === dergi ? (
                            <div className='resimSelectedBorder'>
                              <div className='resimSelected'></div>
                            </div>
                          ) : null}
                          <img
                            alt=''
                            src={require('../../../assets/png/' + item.image)}
                          />
                          {item.id !== dergi ? (
                            <div className='dergiMask'>
                              Sınıfınız bu dergiye uygun olmadığı için
                              seçemezsiniz.
                            </div>
                          ) : null}
                        </div>
                      )
                    })}
                  </div>
                </>
              ) : (
                <div className='dergiWarning' style={{ ...(!isDergi ? { marginBottom: '2rem' } : {}) }}>
                  <WarningSvg width={'4rem'} heigth={'4rem'} />
                  <div style={{ marginTop: '1rem', fontSize: '13px' }}>
                    Bu dergi türüne abone olamazsınız.
                  </div>
                </div>
              )}
            </div>
            {
              isDergi ? (<>
                <div
                  style={{
                    marginLeft: '0.5rem',
                    marginRight: '0.5rem',
                    marginTop: '1rem',
                  }}
                >
                  <ConditionsCheckBox
                    checkbox={checkbox}
                    setCheckbox={setCheckbox}
                    basvuru_sartlari_title={state?.basvuru_sartlari_title}
                    basvuru_sartlari_aciklama={state?.basvuru_sartlari_aciklama}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '1rem',
                    marginBottom: '2rem',
                  }}
                >
                  <Button
                    block
                    className='tubitakTamamla'
                    onClick={onFinish}
                    style={{
                      marginLeft: '1rem',
                      marginRight: '1rem',
                      backgroundColor: '#285843',
                      borderRadius: '20px',
                      padding: '0.6rem 0',
                    }}
                  >
                    Başvuruyu Tamamla
                  </Button>
                </div>
              </>) : (null)
            }
          </>
        ) : (
          <div className='tcInputDiv'>
            <div className='dergiTitle'>
              Öğrenciye Ait T.C. Kimlik No Giriniz
            </div>
            <input
              type='number'
              max={11}
              value={TC}
              onChange={(e) => {
                if (e.target.value?.length <= 11) {
                  setTC(e.target.value?.trim())
                }
              }}
              placeholder='Örn: 15234587987'
              className='tcInput'
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1rem',
                marginBottom: '2rem',
              }}
            >
              <Button
                block
                className='tubitakTamamla'
                onClick={() => {
                  if (TC?.length === 11) {
                    checkStudent().then((res) => {
                      if (res.data.code === 200 && res.data.are_there_student) {
                        setStudendtTC(TC)
                      } else if (res.data.code === 200 && !res.data.are_there_student) {
                        setWarningModalOpen({
                          state: 'noSuccess',
                          active: true,
                        })
                      } else if (res.data.code === 400) {
                        setWarningModalOpen({
                          state: 'responseMessage',
                          active: true,
                          message: res.data.message,
                        })
                      }
                    })
                  } else {
                    setWarningModalOpen({ state: 'noSuccess', active: true })
                  }
                }}
                style={{
                  backgroundColor: '#285843',
                  borderRadius: '20px',
                  padding: '0.6rem 0',
                }}
              >
                Öğrenci Bilgilerini Getir
              </Button>
            </div>
          </div>
        )}
        {ilceler ? (
          <IlceModal
            show={ilceModalOpen}
            onHide={() => setIlceModalOpen(false)}
            setIlce={setSelectedIlce}
            setIlceId={setIlceId}
            setMahalleAdi={setSelectedMahalle}
            setMahalleid={setSelectedMahalleId}
            ilceler={ilceler}
          />
        ) : null}
        {mahalleler ? (
          <MahalleModal
            show={mahalleModalOpen}
            onHide={() => setMahalleModalOpen(false)}
            setMahalleAdi={setSelectedMahalle}
            setMahalleid={setSelectedMahalleId}
            mahalleler={mahalleler}
            setMahalleClass={() => {
              setMahalleInputClass('selectInput')
              setMahalleLabelClass('selectLabel')
            }}
          />
        ) : null}
        <TubitakWarningModal
          show={warningModalOpen.active}
          onHide={() => setWarningModalOpen({ state: '', active: false })}
          studendttc={TC}
          state={warningModalOpen.state}
          message={warningModalOpen.message}
          secondadress={
            selectedAddress === 'yeni' ? secondAdress : labelAddress
          }
          selectedadress={selectedAddress}
          ogrenciBasvuruOnClick={() => {
            const send_data = {}
            // --> Başvuru Id <--
            send_data.id = state?.basvuru_id

            // --> Başvuran <--
            // ÖĞRENCİ
            if (selectedValue === 'Öğrenci') {
              send_data.basvuran = {
                type: 'ogrenci',
              }
            }
            // VELİ
            else if (selectedValue === 'Veli') {
              send_data.basvuran = {
                type: 'veli',
                ogrenci_no: TC,
              }
            }

            // --> Adres <--
            // İkametgah Adres
            if (selectedAddress === 'ikametgah') {
              send_data.adres = {
                type: 'ikametgah',
              }
            }
            // Yeni Adres
            else if (selectedAddress === 'yeni') {
              send_data.adres = {
                type: 'yeni',
                ilce: selectedIlce,
                ...(ilceId === 684 ? { mahalle: selectedMahalle } : {}),
                adres: secondAdress,
              }
            }

            // --> Sözleşme <--
            // İkametgah Adres
            if (checkbox) {
              send_data.sozlesme = true
            }
            // Yeni Adres
            else if (!checkbox) {
              send_data.sozlesme = false
            }
            setLoading(true)
            axios
              .post(
                `${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/ogrenci_basvuru`,
                {
                  data: JSON.stringify(send_data),
                  token: JSON.parse(localStorage.getItem('token')),
                }
              )
              .then((res) => {
                setLoading(false)
                if (res.data.code === 200) {
                  navigate('/success-applications', {
                    state: { id: res.data.result },
                  })
                } else if (res.data.code === 400) {
                  setWarningModalOpen({
                    state: 'responseMessage',
                    active: true,
                    message: res.data.message,
                  })
                }
              })
          }}
        />
      </div>
    </>
  )
}

export default ApplicationsForm
